import { SelectOption } from "../types";

export interface Format extends SelectOption {
  format: string;
  mimetype: string;
}

export const EXCEL: Format = {
  label: ".XLS",
  format: "xlsx",
  id: "excel",
  mimetype: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
};

export const CSV: Format = {
  label: ".CSV",
  format: "csv",
  id: "csv",
  mimetype: "text/csv",
};

export const FILES_FORMAT: Format[] = [EXCEL, CSV];

export const PDF_TYPE = "application/pdf";
